var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import * as moment from 'moment';
var Slot = /** @class */ (function (_super) {
    __extends(Slot, _super);
    function Slot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Slot";
        return _this;
    }
    Slot.isWithinDayRange = function (slot, time) {
        var start = moment(slot.startDate);
        var end = moment(slot.endDate);
        if (slot.startTime && slot.endTime) {
            var startTime = moment(slot.startTime, "HH:mm");
            var endTime = moment(slot.endTime, "HH:mm");
            end = endTime < startTime ? moment((slot.endDate + " " + slot.endTime), "YYYY-MM-DD HH:mm") : moment(slot.endDate);
        }
        end.add("day", 1);
        var now = moment(time);
        //console.log("is within?", now.toISOString(), start.toISOString(), end.toISOString());
        return Slot.between(start, end, now);
    };
    //inclusive start, exclusive end
    Slot.between = function (start, end, time) {
        var ms = time.valueOf();
        return ms >= start.valueOf() && ms < end.valueOf();
    };
    Slot.isTimeOpen = function (slot, time, checkWeekdays) {
        var startTime = slot.startTime;
        var endTime = slot.endTime;
        var start = moment(startTime, "HH:mm");
        var end = moment(endTime, "HH:mm");
        if (!start || !end) {
            console.log("invalid start / end, period invalid");
            return false;
        }
        var now = moment(time);
        var weekday = now.day();
        var overNextDay = end < start;
        var isOverDay = overNextDay && (slot.weekday - weekday == -1 || slot.weekday - weekday == 6);
        if (checkWeekdays && weekday != slot.weekday && slot.weekday < 10) {
            console.log("wrong weekday");
            if (!isOverDay) {
                return false;
            }
        }
        if (!Slot.isOpenType(slot)) {
            //if slot time is closed and it's matching day, always closed
            return false;
        }
        console.log("right weekday", slot.weekday);
        start.year(now.year());
        start.month(now.month());
        start.dayOfYear(now.dayOfYear());
        end.year(now.year());
        end.month(now.month());
        end.dayOfYear(now.dayOfYear());
        if (overNextDay) {
            console.log("stepped over time to next day!!!");
            if (weekday == 0) {
                if (now > end && isOverDay) {
                    end = end.add(24, 'hours');
                }
                else if (isOverDay) {
                    start = start.add(-24, 'hours');
                }
            }
            else if (now > end) {
                end = end.add(24, 'hours');
            }
            else if (isOverDay || slot.weekday > 10) {
                start = start.add(-24, 'hours');
            }
        }
        console.log("start moment", start.toDate());
        console.log("now moment", now.toDate());
        console.log("end moment", end.toDate());
        var within = Slot.between(start, end, now);
        return within;
    };
    Slot.isWeekdayOpen = function (slot, time) {
        var now = moment(time);
        var weekday = now.day();
        if (weekday != slot.weekday) {
            return false;
        }
        var startTime = slot.startTime;
        var endTime = slot.endTime;
        if (startTime && endTime)
            return Slot.isOpenType(slot);
        return false;
    };
    Slot.isDateOpen = function (slot, time) {
        var now = moment(time);
        var startTime = slot.startTime;
        var endTime = slot.endTime;
        if (startTime && endTime)
            return Slot.isOpenType(slot);
        return false;
    };
    Slot.isOpenType = function (slot) {
        if (slot.type) {
            return "open" == slot.type;
        }
        return true;
    };
    return Slot;
}(Data));
export { Slot };
//# sourceMappingURL=slot.js.map